import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.page.html',
  styleUrls: ['./forgetpassword.page.scss']
})
export class ForgetpasswordPage implements OnInit, OnDestroy {

  public forgotPasswordForm: FormGroup;

  constructor(private formBuilder: FormBuilder ) {
  }

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required]],
    })
  }

  get f() { return this.forgotPasswordForm.controls; }

  ngOnDestroy() {

  }

}
